import { Node, mergeAttributes } from '@tiptap/core'
import type { RawCommands } from '@tiptap/core'

export type MergeTagType =
  | 'first-name-merge-tag'
  | 'last-name-merge-tag'
  | 'full-name-merge-tag'

const LABELS: Record<MergeTagType, string> = {
  'first-name-merge-tag': '<...> First name',
  'last-name-merge-tag': '<...> Last name',
  'full-name-merge-tag': '<...> Full name',
}

const TEMPLATE_VARS: Record<MergeTagType, string> = {
  'first-name-merge-tag': 'first_name',
  'last-name-merge-tag': 'last_name',
  'full-name-merge-tag': 'full_name',
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    mergeTag: {
      insertMergeTag: (tagType: MergeTagType) => ReturnType
    }
  }
}

export const MergeTagNode = Node.create({
  name: 'mergeTag',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      tagType: { default: 'first-name-merge-tag' },
      label: { default: '' },
      templateVar: { default: '' },
    }
  },

  parseHTML() {
    return [{ tag: 'span[data-merge-tag]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        'data-merge-tag': HTMLAttributes.tagType,
        class: 'rte-merge-tag',
        contenteditable: 'false',
      }),
      HTMLAttributes.label || HTMLAttributes.templateVar,
    ]
  },

  addCommands() {
    return {
      insertMergeTag:
        (tagType: MergeTagType) =>
        ({ commands }) => {
          return commands.insertContent({
            type: 'mergeTag',
            attrs: {
              tagType,
              label: LABELS[tagType],
              templateVar: TEMPLATE_VARS[tagType],
            },
          })
        },
    } as Partial<RawCommands>
  },
})
